import React from 'react'
import numberHelper from '../../util/numberFormatter'
import dateHelper from '../../util/dateFormatter'
import { Link } from 'react-router-dom';

const CategoryLogList = props => {
    if (!props.logs) {
        return (
            <div className='broad'>Loading...</div>
        );
    }

    if (props.logs.length === 0) {
        return (
            <div className='empty'>
                No logs...
      </div>
        );
    }

    return (
        <div>
            <table className="dataTable">
                <thead>
                    <tr>
                        <th>operator</th>
                        <th>previous state</th>
                        <th>current state</th>
                        <th>Created</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        props.logs.map(item => {
                            return (
                                <tr key={item.key}>
                                    <td className="keyfield"><Link to={`/users/${item.operator}`}>{item.operator}</Link></td>
                                    <td className="keyfield">
                                        <strong>Name:</strong> {item.previous_variable.name} <br />
                                    </td>
                                    <td className="keyfield">
                                        <strong>Name:</strong> {item.current_variable.name} <br />
                                    </td>
                                    <td>{dateHelper.Formatter.toLocalString(item.created)}</td>
                                </tr>
                            )
                        })
                    }
                </tbody>
            </table>
        </div>
    );
};

export default CategoryLogList;



// WEBPACK FOOTER //
// ./src/components/widgets/CategoryLogList.js